import { localizeMenuItemName } from '@/config/routeLabels';
import type { AppMenuItem } from '@/config/types';
import type { AppLocale } from '@/stores/localeStore';
export function searchMenu(
  items: AppMenuItem[],
  query: string,
  locale: AppLocale = 'zh-CN',
  ancestors: string[] = [],
): AppMenuItem[] {
  const needle = query.toLocaleLowerCase().replace(/\s+/g, '');
  return items.flatMap((item) => {
    const trail = [
      ...ancestors,
      `${item.name} ${item.nameEn ?? ''} ${localizeMenuItemName(item, locale)}`,
    ];
    if (item.children) return searchMenu(item.children, query, locale, trail);
    if (!item.path || !item.pageKind) return [];
    const haystack = `${trail.join(' ')} ${item.path}`.toLocaleLowerCase();
    let cursor = 0;
    for (const char of haystack) if (char === needle[cursor]) cursor++;
    return cursor === needle.length ? [item] : [];
  });
}
